// You can add more open point postcodes here. Google doesn't seem to know about the following postcodes:
export default [
  {from: '3502', to: '3501'},
  {from: '3503', to: '3501'},
  {from: '3504', to: '3501'}
];